import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowLeft } from "lucide-react";
import { DIRECTORS } from "@/lib/directors";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";

export default function Directors() {
  return (
    <div className="min-h-screen bg-white" data-testid="directors-page">
      <Navbar onQuote={() => (window.location.href = "/#contact")} />

      <section className="pt-32 md:pt-40 pb-20 relative overflow-hidden">
        <div className="absolute -top-32 right-0 w-[600px] h-[600px] rounded-full vc-gradient opacity-15 blur-3xl pointer-events-none" />
        <div className="absolute inset-0 vc-grid-bg pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-5 md:px-10">
          <Link
            to="/"
            data-testid="back-home"
            className="inline-flex items-center gap-2 text-sm font-semibold text-neutral-600 hover:text-neutral-900 transition-colors mb-6"
          >
            <ArrowLeft size={16} /> Back to home
          </Link>

          <div className="font-mono-vc text-xs uppercase tracking-[0.25em] vc-text-gradient font-bold">
            Director&apos;s Message
          </div>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] text-neutral-900 max-w-4xl">
            Meet the leadership behind <span className="vc-text-gradient">VersaCorp</span>.
          </h1>
          <p className="mt-6 text-neutral-600 text-base md:text-lg max-w-2xl leading-relaxed">
            VersaCorp is led by directors who bring decades of combined experience in manufacturing,
            governance, and sustainability. Read their personal messages below.
          </p>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-5 md:px-10 grid md:grid-cols-3 gap-6">
          {DIRECTORS.map((d) => (
            <Link
              key={d.slug}
              to={`/directors/${d.slug}`}
              data-testid={`director-card-${d.slug}`}
              className="group relative rounded-3xl border border-neutral-200 bg-white overflow-hidden hover:-translate-y-1 hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={d.photo}
                  alt={d.name}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute inset-x-5 bottom-5 text-white">
                  <div className="font-display text-2xl font-extrabold leading-tight">{d.name}</div>
                  <div className="text-xs text-white/80 mt-1">{d.title}</div>
                </div>
              </div>
              <div className="p-6 flex items-center justify-between gap-4">
                <p className="text-sm text-neutral-600 leading-relaxed">{d.short}</p>
                <span className="shrink-0 w-10 h-10 rounded-full border border-neutral-200 flex items-center justify-center text-neutral-700 group-hover:vc-gradient group-hover:text-white group-hover:border-transparent transition-all">
                  <ArrowUpRight size={16} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
      <WhatsAppFab />
    </div>
  );
}
